import { render, staticRenderFns } from "./NotRecordNameWriteVotes.vue?vue&type=template&id=f8674e20&scoped=true"
import script from "./NotRecordNameWriteVotes.vue?vue&type=script&lang=js"
export * from "./NotRecordNameWriteVotes.vue?vue&type=script&lang=js"
import style0 from "./NotRecordNameWriteVotes.vue?vue&type=style&index=0&id=f8674e20&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8674e20",
  null
  
)

export default component.exports